import { MemberGroups } from "shared-types";
import authorizationService from "../services/authorization/authorizationService";

export function checkIsYp() {
  return authorizationService.getUserGroup() === MemberGroups.yPerformer;
}
